import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Report({ lang }) {
  const [userRole, setUserRole] = useState();

  useEffect(() => {
    const storedUser = JSON.parse(
      JSON.parse(sessionStorage.getItem("aman-admin")).admin,
    );
    if (storedUser) {
      setUserRole(storedUser.role);
    }
  }, []);
  return (
    <>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>{lang.Reports || "Reports"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item active">
                {lang.Reports || "Reports"}
              </li>
            </ol>
          </nav>
        </div>
        <section className="section">
          <div className="row">
            {/* ================= Administration Reports ================= */}
            <div className="col-lg-4">
              <div className="card">
                <div className="card-header fw-bold">
                  {lang.Administration_Reports || "Administration Reports"}
                </div>
                <div className="card-body">
                  <Link
                    className="d-flex align-items-center mb-3"
                    to="operational-report"
                  >
                    <img src="/img/folder.png" width="24" alt="" />
                    <span className="ms-2">
                      {lang["Operational Report"] || "Operational Report"}
                    </span>
                  </Link>
                  <Link
                    className="d-flex align-items-center mb-3"
                    to="shift-report"
                  >
                    <img src="/img/folder.png" width="24" alt="" />
                    <span className="ms-2">
                      {lang["Detailed Operational Report"] ||
                        "Detailed Operational Report"}
                    </span>
                  </Link>
                  <Link
                    className="d-flex align-items-center mb-3"
                    to="expense-report"
                  >
                    <img src="/img/folder.png" width="24" alt="" />
                    <span className="ms-2">{lang.Expenses || "Expenses"}</span>
                  </Link>
                </div>
              </div>
            </div>

            {/* ================= User Reports ================= */}
            <div className="col-lg-4">
              <div className="card">
                <div className="card-header fw-bold">
                  {lang.User_Reports || "User Reports"}
                </div>
                <div className="card-body">
                  <Link
                    className="d-flex align-items-center mb-3"
                    to="investor-user-report"
                  >
                    <img src="/img/User.png" width="24" alt="" />
                    <span className="ms-2">
                      {lang.investor_customer_relation ||
                        "Investor/Customer Relation"}
                    </span>
                  </Link>

                  <Link
                    className="d-flex align-items-center mb-3"
                    to="transaction-report"
                  >
                    <img src="/img/User.png" width="24" alt="" />
                    <span className="ms-2">
                      {lang.investor_transaction_report ||
                        "Investor Transaction Report"}
                    </span>
                  </Link>

                  {userRole === "super" && (
                    <Link
                      className="d-flex align-items-center mb-3"
                      to="dealer-report-list"
                    >
                      <img src="/img/User.png" width="24" alt="" />
                      <span className="ms-2">{lang.Dealers || "Dealers"}</span>
                    </Link>
                  )}
                </div>
              </div>
            </div>

            {/* ================= Contract Reports ================= */}
            <div className="col-lg-4">
              <div className="card">
                <div className="card-header fw-bold">
                  {lang.Contract_Reports || "Contract Reports"}
                </div>
                <div className="card-body">
                  <Link
                    className="d-flex align-items-center mb-3"
                    to="list-of-contract"
                  >
                    <img src="/img/folder.png" width="24" alt="" />
                    <span className="ms-2">
                      {lang.Collections_and_Payments || "Collection & Payment"}
                    </span>
                  </Link>

                  <Link
                    className="d-flex align-items-center mb-3"
                    to="defaulted-contracts"
                  >
                    <img src="/img/folder.png" width="24" alt="" />
                    <span className="ms-2">
                      {lang.Defaulted_Contracts || "Defaulted Contracts"}
                    </span>
                  </Link>

                  <Link
                    className="d-flex align-items-center mb-3"
                    to="contract-profit"
                  >
                    <img src="/img/folder.png" width="24" alt="" />
                    <span className="ms-2">
                      {lang.complete_contract || "Complete Contract"}
                    </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card">
                <div className="card-header fw-bold">
                  {lang["Item Reports"] || "Item Reports"}
                </div>
                <div className="card-body">
                  <Link
                    className="d-flex align-items-center mb-3"
                    to="item-report-list"
                  >
                    <img src="/img/folder.png" width="24" alt="" />
                    <span className="ms-2">{lang.Items || "Items"}</span>
                  </Link>

                  <Link
                    className="d-flex align-items-center mb-3"
                    to="purchase-report"
                  >
                    <img src="/img/folder.png" width="24" alt="" />
                    <span className="ms-2">
                      {lang.purchase_reports || "Purchase Reports"}
                    </span>
                  </Link>

                  <Link
                    className="d-flex align-items-center mb-3"
                    to="sell-item-report"
                  >
                    <img src="/img/folder.png" width="24" alt="" />
                    <span className="ms-2">
                      {lang["Sell Item Report"] || "Sell Item Report"}
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
